module.exports = __webpack_public_path__ + "static/img/2.ce6ba76.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/eng/2.png
// module id = gOey
// module chunks = 0